import ManagementSidebar from './drawer/managementSidebar'
import styled from 'styled-components'
import theme from '~/design'

interface IOptionsMenuProps {
  menuActive?: string
}

const Container = styled.div`
  display: flex;
  flex: 1;
  min-height: 100%;
  padding: 1rem;
  background-color: ${theme.colors.lightText};
`

export default function RecordsMenu({ menuActive: _menuActive }: IOptionsMenuProps) {
  return (
    <Container>
      <ManagementSidebar />
    </Container>
  )
}
